import React from 'react';
import { Box, Typography, Button, Container } from '@mui/material';
import { useNavigate } from 'react-router-dom';
import { useNavbar } from '../../context/NavbarContext';
import './NotFound.css';

const NotFound = () => {
    const navigate = useNavigate();
    const { hideNavbar, showNavbar } = useNavbar();

    React.useEffect(() => {
        hideNavbar();
        return () => showNavbar();
    }, [hideNavbar, showNavbar]);

    return (
        <Box className="nf-hero-section">
            <Container maxWidth="md">
                <Box className="nf-content-wrapper">
                    <div className="nf-glitch-container">
                        <h1 className="nf-glitch-text" data-text="404">404</h1>
                    </div>

                    {/* <Typography variant="h3" className="nf-title">
                        Lost in the Digital Space?
                    </Typography>

                    <Typography variant="body1" className="nf-description">
                        The page you are looking for doesn't exist or has been moved.
                        Don't worry, even the best travelers lose their way sometimes.
                    </Typography> */}

                    <Box className="nf-action-area">
                        {/* <Button
                            variant="contained"
                            className="nf-home-button"
                            onClick={() => navigate('/')}
                        >
                            Take Me Home
                        </Button> */}
                        <Button
                            variant="outlined"
                            className="nf-back-button"
                            onClick={() => navigate(-1)}
                        >
                            Go Back
                        </Button>
                    </Box>
                </Box>
            </Container>

            {/* Animated Background Elements */}
            {/* <div className="nf-bg-glow nf-glow-1"></div>
            <div className="nf-bg-glow nf-glow-2"></div>
            <div className="nf-stars"></div> */}
        </Box>
    );
};

export default NotFound;
